import React from "react";
import clsx from "clsx";

const Line = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={clsx("my-5 h-1 w-16 bg-red-600", className)}
    {...props}
  />
));

Line.displayName = "Line";

const Title = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={clsx(
      "font-kufi text-primary-700 w-fit text-4xl leading-snug tracking-tight dark:text-white",
      className,
    )}
    {...props}
  />
));

Title.displayName = "Title";

const Description = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={clsx("text-muted pt-2 text-sm leading-7", className)}
    {...props}
  />
));

Description.displayName = "Description";

export { Line, Title, Description };
